import type { CardVariant, RelationshipState } from './types'

export type PrimaryAction =
  | 'open-profile'
  | 'open-update'
  | 'see-plans'
  | 'back-to-following'
  | 'follow'
  | 'none'

/**
 * The one orange action of a startup panel or page (spec 14). Everything else on it is quiet.
 *
 * - Panel: "Open profile", except while a follow waits for a free place ("See plans"), once the
 *   founder ended it (nothing), and for a startup with no profile to open (Follow).
 * - Page: it has no "Open profile", so the follow's own action leads: the update that met the
 *   condition, "See plans", "Back to Following", or Follow for a startup not followed.
 */
export function primaryAction(input: {
  state: RelationshipState
  variant: CardVariant
  hasProfileLink: boolean
}): PrimaryAction {
  const { state, variant, hasProfileLink } = input
  if (state === 'WAITING_PLACE') return 'see-plans'
  if (variant === 'panel') {
    if (state === 'ENDED_BY_FOUNDER') return 'none'
    if (!hasProfileLink) return state === 'NONE' ? 'follow' : 'none'
    return 'open-profile'
  }
  switch (state) {
    case 'CONDITION_MET':
      return 'open-update'
    case 'ENDED_BY_FOUNDER':
      return 'back-to-following'
    case 'NONE':
      return 'follow'
    default:
      return 'none'
  }
}
